<div class="login-page">
    <div class="login-page-video"></div>
    <section class="login-page-body">
        <ng-content select="[auth-body]"></ng-content>
    </section>
    <main class="login-page-sidebar">
        <ng-content select="[auth-sidebar]"></ng-content>
    </main>
</div>